import { useMemo } from 'react';
import { useMatches } from 'react-router';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const schema = z.object({
  ViewsFilter: z.function().returns(z.any()),
});

export function ViewsFilter() {
  const matches = useMatches();

  const RouteViewsFilter = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = schema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.ViewsFilter;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteViewsFilter === undefined) {
    return null;
  }

  return (
    <div>
      <RouteViewsFilter />
    </div>
  );
}
